<div class="create-prompt-title">
<h2 mat-dialog-title>Create Prompt</h2>
</div>
<div class="create-prompt-content">
<mat-dialog-content>
  <form [formGroup]="promptForm" class="prompt-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter prompt name">
      <mat-hint class="prompt-name-hint">
        Character count: {{ promptForm.get('name')?.value?.length || 0 }} / 100

        <button matIconButton type="button" #tooltip="matTooltip" aria-label="How to use the Automation Library"
          [matTooltip]="tooltipText" matTooltipPosition="below">
          <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true" fontIcon="info" />
        </button>
      </mat-hint>
      @if (promptForm.get('name')?.hasError('required')) {
        <mat-error>
          Name is required
        </mat-error>
      }
      @if (promptForm.get('name')?.hasError('maxlength')) {
        <mat-error>
          Name cannot exceed 100 characters
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Type</mat-label>
      <input matInput formControlName="type" readonly>
      <mat-hint class="type-hint">To update the Type, go into Edit Instructions</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="prompt-form-field">
      <mat-label>Prompt</mat-label>
      <textarea matInput formControlName="prompt" rows="5"></textarea>
      @if (promptForm.get('prompt')?.hasError('required')) {
        <mat-error>
          Prompt is required
        </mat-error>
      }
    </mat-form-field>


    @if (slEnabled()) {
    <mat-hint>
      The current Session's Sensitivity Label will be selected as the default. You can select additional labels for the prompt.
    </mat-hint>
    <mat-expansion-panel class="sensitivity-labels-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Sensitivity Labels
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="treeview-container">
        <div class="treeview-wrapper">
          <kendo-treeview
            [nodes]="sensitivityLabelData()"
            textField="name"
            idField="id"
            parentIdField="parent"
            checkBy="id"
            [filterable]="false"
            [loadOnDemand]="false"
            [(checkedKeys)]="checkedKeys"
            [expandedKeys]="expandedKeys"
            [hasCheckbox]="hasCheckbox"
            (checkedChange)="onSelectionChange($event)"
            kendoTreeViewFlatDataBinding
            kendoTreeViewExpandable
            [kendoTreeViewDisable]="'label'"
            [kendoTreeViewCheckable]="checkableSettings"
            >
            <ng-template kendoTreeViewNodeTemplate let-dataItem>
              <div class="tree-node">
                <mat-icon
                  class="material-symbols-outlined"
                  [style.color]="dataItem.color || null"
                  [fontIcon]="dataItem.icon"/>
                  <span>{{ dataItem.name }}</span>
                </div>
              </ng-template>
            </kendo-treeview>
            @if (promptForm.get('sensitivityLabels')!.hasError('sensitivityLabelInvalid')) {
              <mat-error class="mat-mdc-form-field-error error">At least one Sensitivity Label is required.</mat-error>
            }
          </div>
        </div>
      </mat-expansion-panel>
    }

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button matButton (click)="onCancel()">Cancel</button>
    <button matButton="filled" (click)="quickAddPrompt()" [disabled]="promptForm.invalid">Save</button>
  </mat-dialog-actions>
</div>
